import styled from 'styled-components';

export const ObsoleteOfferNote = styled.div`
  margin: 10px 0 0 0;
  font-size: 14px;
  font-weight: normal;
  color: ${props => props.theme.colors.warning};
`;
